<template>
  <div>
    <v-row
      v-if="
        indicacoesDesempenhoSemInviabilizados.length > 0 &&
          unidades.selecionado.length > 0
      "
    >
      <!-- pie chart de complexidade -->
      <v-col cols="12">
        <pie-chart-indicacoes-desenvolvimento
          :com-sub-piechart="comSubPiechart"
          :fonte="fontePieChart"
          :indicacoes-desempenho="indicacoesDesempenhoSemInviabilizados"
          :titulo="tituloPieChart"
          :is-get-svg="isGetSvg"
          @svg="(value) => svg = value"
        />

        <v-row
          v-if="unidadesSemIndicacao.length > 0"
          class="justify-center"
        >
          <p class="caption text-center">
            {{ msgUnidadesSemIndicacao }}
          </p>
        </v-row>

        <!-- legenda do pie chart -->
        <v-row class="justify-center">
          <legenda-complexidade />
        </v-row>

        <!-- tabela de resultados -->
        <v-row v-if="!isUmaUnidade">
          <v-col>
            <v-data-table
              :headers="headersResultados"
              :items="indicacoesDesempenhoAgregado"
              class="elevation-0"
            >
              <template v-slot:top>
                <v-row class="mb-2">
                  <v-toolbar flat>
                    <v-toolbar-title>
                      <h2
                        class="title primary--text text--darken-1 text-no-wrap"
                      >
                        {{ tituloTabelaResultados }}
                      </h2>
                    </v-toolbar-title>
                  </v-toolbar>
                </v-row>
              </template>

              <!-- total de quantidades -->
              <template v-slot:[`body.append`]>
                <tr>
                  <td />
                  <td align="center">
                    <strong
                      class="subtitle-2 grey--text text--darken-2"
                    >TOTAL</strong>
                  </td>
                  <td
                    v-for="(total, i) in totalIndicacoes"
                    :key="i"
                    align="center"
                  >
                    <strong>{{ total }}</strong>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- quadro resumo -->
        <v-row v-if="isUmaUnidade">
          <v-col>
            <v-data-table
              :headers="headersResultados"
              :items="indicacoesDesempenhoAgregado"
              class="elevation-0"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-row class="mb-2">
                  <v-toolbar flat>
                    <v-toolbar-title>
                      <h2
                        class="title primary--text text--darken-1 text-no-wrap"
                      >
                        {{ tituloTabelaResultados }}
                      </h2>
                    </v-toolbar-title>
                  </v-toolbar>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- tabela de indicações de desenvolvimento -->
        <v-row v-if="isUmaUnidade">
          <v-col>
            <tabela-indicacao-desenvolvimento
              :indicacoes-desempenho="indicacoesDesempenhoSemInviabilizados"
            />
          </v-col>
        </v-row>

        <!-- indicações de competências técnicas -->
        <v-row>
          <v-col>
            <tabela-indicacao-competencia-tecnica
              :indicacoes-competencia="indicacoesCompetencia"
              :titulo="tituloIndicacoesCompetenciaTecnica"
            />
          </v-col>
        </v-row>

        <!-- tabela de resultados inviabilizados - servidor -->
        <v-row
          v-if="resultadosInviabilizadosServidor.length > 0 && isUmaUnidade"
        >
          <v-col>
            <v-data-table
              :headers="headerInviabilizadosServidor"
              :items="resultadosInviabilizadosServidor"
              class="elevation-0"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-row class="mb-2">
                  <v-toolbar flat>
                    <v-toolbar-title>
                      <h2
                        class="title primary--text text--darken-1 text-no-wrap"
                      >
                        DESEMPENHOS TÉCNICOS INVIABILIZADOS
                      </h2>
                    </v-toolbar-title>
                  </v-toolbar>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- tabela de resultados inviabilizados - unidade -->
        <v-row v-if="unidadesSemIndicacao.length > 0 && !isUmaUnidade">
          <v-col>
            <v-data-table
              :headers="headerInviabilizadosUnidade"
              :items="unidadesSemIndicacao"
              class="elevation-0"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-row class="mb-2">
                  <v-toolbar flat>
                    <v-toolbar-title>
                      <h2
                        class="title primary--text text--darken-1 text-no-wrap"
                      >
                        DESEMPENHOS TÉCNICOS INVIABILIZADOS ({{
                          unidadesSemIndicacaoSiglas
                        }})
                      </h2>
                    </v-toolbar-title>
                  </v-toolbar>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- botão para geração do PDF -->
        <v-row class="justify-end">
          <v-tooltip
            max-width="400"
            top
          >
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-2"
                color="success"
                @click="getRelatorio()"
                v-on="on"
              >
                <v-icon>get_app</v-icon>
                BAIXAR PDF
              </v-btn>
            </template>
            <span>Clique para baixar o relatório dos dados em formato PDF.</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>

    <!-- alerta para o caso de não haver desempenho viabilizado na unidade -->
    <v-row v-else-if="unidades.selecionado.length > 0">
      <v-col>
        <app-alert
          message="Não há desempenhos viabilizados na(s) unidade(s)"
          icon="info"
          type="info"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import AppAlert from '@/components/core/AppAlert';
import TabelaIndicacaoDesenvolvimento
from '@/components/monitoramento/desempenho/tecnico/TabelaIndicacaoDesenvolvimento';
import TabelaIndicacaoCompetenciaTecnica
from '@/components/monitoramento/desempenho/tecnico/TabelaIndicacaoCompetenciaTecnica';
import PieChartIndicacoesDesenvolvimento
from '@/components/monitoramento/desempenho/tecnico/PieChartIndicacoesDesenvolvimento';
import LegendaComplexidade from '@/components/monitoramento/desempenho/tecnico/LegendaComplexidade';
import { sum } from 'mathjs';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Data from '@/modules/data';

const resultadoResponsabilidadeRepository = RepositoryFactory.get('resultadoResponsabilidade');

export default {
  name: 'RelatorioGerencialResponsabilidade',

  components: {
    AppAlert,
    TabelaIndicacaoDesenvolvimento,
    TabelaIndicacaoCompetenciaTecnica,
    LegendaComplexidade,
    PieChartIndicacoesDesenvolvimento,
  },

  props: {
    diagnostico: {
      type: Object,
      required: true,
    },
    unidades: {
      type: Object,
      required: true,
      default: () => ({
        isTodasSelecionadas: false,
        selecionado: [],
        visualizacao: '',
      }),
    },
    isUmaUnidade: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      resultadosResponsabilidade: [],
      headersResultados: [
        { text: 'NOME DA UNIDADE', value: 'nomeUnidade', sortable: false },
        {
          text: 'SIGLA DA UNIDADE',
          value: 'siglaUnidade',
          width: '10%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'INDICAÇÕES DE COMPLEXIDADE ALTA',
          value: 'alta',
          width: '15%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'INDICAÇÕES DE COMPLEXIDADE MÉDIA',
          value: 'media',
          width: '15%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'INDICAÇÕES DE COMPLEXIDADE BAIXA',
          value: 'baixa',
          width: '15%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'DESEMPENHOS TÉCNICOS INVIABILIZADOS',
          value: 'nInviabilizados',
          width: '10%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'TOTAL DE SERVIDORES',
          value: 'nServidores',
          width: '10%',
          sortable: false,
          align: 'center',
        },
      ],
      headerInviabilizadosServidor: [
        {
          text: 'SERVIDOR',
          value: 'nomeUsuario',
          sortable: false,
          width: '50%',
          align: 'left',
        },
        {
          text: 'MOTIVO',
          value: 'motivoTecnicoInviabilizado',
          sortable: false,
          width: '50%',
          align: 'left',
        },
      ],
      headerInviabilizadosUnidade: [
        {
          text: 'NOME DA UNIDADE',
          value: 'nome',
          sortable: false,
          width: '80%',
          align: 'left',
        },
        {
          text: 'SIGLA DA UNIDADE',
          value: 'sigla',
          sortable: false,
          width: '20%',
          align: 'left',
        },
      ],
      isGetSvg: false,
      svg: null,
    };
  },

  computed: {
    ...mapState({
      competenciasTecnicas: (state) => state.competencia.competenciasTecnicas,
    }),
    unidadesComIndicacao() {
      return _(this.indicacoesDesempenhoSemInviabilizados).uniqBy('idUnidadeVersao').value();
    },
    unidadesComIndicacaoSiglas() {
      if (this.unidadesComIndicacao.length === this.unidades.selecionado.length) {
        return 'TODAS';
      }

      return this.unidadesComIndicacao.map((u) => u.siglaUnidade).join(', ');
    },
    totalIndicacoes() {
      return [
        _(this.indicacoesDesempenhoAgregado).sumBy('alta'),
        _(this.indicacoesDesempenhoAgregado).sumBy('media'),
        _(this.indicacoesDesempenhoAgregado).sumBy('baixa'),
        _(this.indicacoesDesempenhoAgregado).sumBy('nInviabilizados'),
        _(this.indicacoesDesempenhoAgregado).sumBy('nServidores'),
      ];
    },
    unidadesSemIndicacao() {
      return _.differenceWith(
        this.unidades.selecionado,
        this.unidadesComIndicacao,
        (us, uc) => us.idVersao === uc.idUnidadeVersao,
      );
    },
    unidadesSemIndicacaoSiglas() {
      if (this.unidadesSemIndicacao.length === this.unidades.selecionado.length) {
        return 'TODAS';
      }

      return this.unidadesSemIndicacao.map((u) => u.sigla).join(', ');
    },
    indicacoesDesempenhoAgregado() {
      const mComplexidadeQtdResultadosDefault = { alta: 0, media: 0, baixa: 0 };
      return _(this.indicacoesDesempenhoSemInviabilizados)
        .groupBy('idUnidadeVersao')
        .map((v, k) => {
          const kInt = Number(k);
          return {
            siglaUnidade: v[0].siglaUnidade,
            nomeUnidade: v[0].nomeUnidade,
            nServidores: _(this.resultadosResponsabilidade)
              .uniqBy('idUsuario')
              .filter((rr) => rr.idUnidadeVersao === kInt)
              .value().length,
            ...mComplexidadeQtdResultadosDefault,
            ..._(v)
              .filter((i) => !i.isTecnicoInviabilizado)
              .countBy('complexidadeResponsabilidade.nome')
              .value(),
            nInviabilizados: _(this.resultadosInviabilizados)
              .uniqBy('idUsuario')
              .filter((ri) => ri.idUnidadeVersao === kInt)
              .value().length,
          };
        })
        .value();
    },
    indicacoesCompetencia() {
      return _(this.indicacoesDesempenho)
        .flatMap((r) => r.competenciasTecnicas)
        .groupBy('id')
        .map((v, k) => {
          const competencia = this.competenciasTecnicas.find((c) => c.id === parseInt(k, 10));
          return {
            nomeCompetencia: competencia ? competencia.nomeAtual : '',
            nIndicacoes: v.length,
            isGeral: competencia ? competencia.unidades.length === 0 : false,
          };
        })
        .value()
        .sort((a, b) => a.nomeCompetencia.localeCompare(b.nomeCompetencia));
    },
    tituloTabelaResultados() {
      if (this.isUmaUnidade) {
        return 'QUADRO RESUMO DO DESEMPENHO TÉCNICO';
      }
      return `RESULTADOS (${this.unidadesComIndicacaoSiglas})`;
    },
    tituloIndicacoesCompetenciaTecnica() {
      return `INDICAÇÕES DE COMPETÊNCIAS TÉCNICAS (${this.unidadesComIndicacaoSiglas})`;
    },
    tituloPieChart() {
      return `Comparativo de Complexidades das Indicações de Desenvolvimento ${
        this.isUmaUnidade ? `da ${this.unidades.selecionado[0].sigla}` : this.unidades.visualizacao
      } ${this.unidadesSemIndicacao.length ? '*' : ''}`;
    },
    fontePieChart() {
      return `Fonte: Sistema Desenvolva, ${this.diagnostico.ano}`;
    },
    msgUnidadesSemIndicacao() {
      const unidadesSemIndicacaoStr = this.unidadesSemIndicacao.map((u) => u.sigla).join(', ');
      if (this.unidadesSemIndicacao.length === 1) {
        return `* A unidade ${unidadesSemIndicacaoStr} não possui resultado viabilizado.`;
      }
      return `* As unidades ${unidadesSemIndicacaoStr} não possuem resultado viabilizado.`;
    },
    indicacoesDesempenho() {
      return this.resultadosResponsabilidade.filter((rr) => rr.isIndicacaoDesenvolvimento);
    },
    indicacoesDesempenhoSemInviabilizados() {
      return this.resultadosResponsabilidade.filter(
        (rr) => rr.isIndicacaoDesenvolvimento && !rr.isTecnicoInviabilizado,
      );
    },
    resultadosInviabilizados() {
      return this.resultadosResponsabilidade.filter((rr) => rr.isTecnicoInviabilizado);
    },
    resultadosInviabilizadosServidor() {
      return _(this.resultadosInviabilizados)
        .uniqBy('idUnidadeVersao')
        .sort((a, b) => a.nomeUsuario.localeCompare(b.nomeUsuario))
        .value();
    },
    resultadosInviabilizadosUnidade() {
      return _(this.resultadosInviabilizados)
        .uniqBy('idUnidadeVersao')
        .sort((a, b) => a.nomeUnidade.localeCompare(b.nomeUnidade))
        .value();
    },
    comSubPiechart() {
      return !this.isUmaUnidade;
    },
  },

  watch: {
    diagnostico() {
      this.loadResultado();
    },
    'unidades.selecionado': function () {
      this.loadResultado();
    },
  },

  methods: {
    loadResultado() {
      if (this.unidades.selecionado.length === 0) {
        this.resultadosResponsabilidade = [];
      } else {
        const unidadesIds = this.unidades.selecionado.map((u) => u.idVersao);
        resultadoResponsabilidadeRepository.getByDiagnosticoUnidades(this.diagnostico.id, unidadesIds).then((res) => {
          this.resultadosResponsabilidade = res.data;
        });
      }
    },
    getUnidadeSiglaAndNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
    async getRelatorio() {
      this.isGetSvg = true;
      await preparePdf(async () => {
        const inicio = Data.format(this.diagnostico.inicioResponsabilidadeChefia);
        const fim = Data.format(this.diagnostico.fimResponsabilidadeServidor);

        const documento = {
          nome: `relatorio-desempenho-responnsabilidade-${this.isUmaUnidade ? 'unidade' : 'geral'}-${
            this.diagnostico.id}`,
          orientacao: 'landscape',
          cabecalho: {
            titulo: this.isUmaUnidade ? 'Desempenho Técnico da Unidade' : 'Desempenho Técnico Geral',
            itens: [
              `Diagnóstico: ${this.diagnostico.nome}`,
              `Período de Avaliação: ${inicio} a ${fim}`,
              `${this.isUmaUnidade ? 'Unidade:' : 'Unidades Viabilizadas:'} ${
                this.unidadesComIndicacao.map((u) => u.siglaUnidade)}`,
              this.isUmaUnidade ? undefined
                : `Unidade Inviabilizadas: ${this.unidadesSemIndicacao.map((u) => u.sigla)}`,
            ],
          },
          blocos: [
            {
              titulo: 'GRÁFICOS',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg) },
              ],
            },
            {
              titulo: this.isUmaUnidade ? 'QUADRO RESUMO' : 'RESULTADOS DAS UNIDADES VIABILIZADAS',
              itens: [{
                tipo: 'tabela',
                valor: {
                  simples: this.isUmaUnidade,
                  colunas: [
                    'UNIDADE',
                    'INDICAÇÕES\nDE COMPLEXI-\nDADE ALTA',
                    'INDICAÇÕES\nDE COMPLEXI-\nDADE MÉDIA',
                    'INDICAÇÕES\nDE COMPLEXI-\nDADE BAIXA',
                    'DESEMPENHOS\nTÉCNICOS\nINVIABILIZADOS',
                    'TOTAL DE\nSERVIDORES',
                  ],
                  linhas: this.indicacoesDesempenhoAgregado.map((i) => [
                    `${i.nomeUnidade} (${i.siglaUnidade})`,
                    i.alta,
                    i.baixa,
                    i.media,
                    i.nInviabilizados,
                    i.nServidores,
                  ]),
                  rodape: this.isUmaUnidade ? undefined : ['TOTAL', ...this.totalIndicacoes.map((t) => t)],
                },
              }],
            },
            {
              titulo: 'INDICAÇÕES DE COMPETÊNCIAS TÉCNICAS',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: ['COMPETÊNCIA', 'QUANTIDADE'],
                  linhas: [
                    ...this.indicacoesCompetencia.map((i) => [
                      i.nomeCompetencia,
                      i.nIndicacoes,
                    ]),
                  ],
                  customizacoes: [
                    {
                      secao: 'body',
                      colunas: [1],
                      estilos: [
                        {
                          cor: 'secondary',
                          valores: this.indicacoesCompetencia.filter((i) => i.isGeral).map((i) => i.nomeCompetencia),
                        },
                      ],
                    },
                  ],
                  rodape: [
                    'TOTAL',
                    this.indicacoesCompetencia.length > 0 ? sum(this.indicacoesCompetencia.map((i) => i.nIndicacoes))
                      : 0,
                  ],
                },
              }],
            },
          ],
        };

        if (this.isUmaUnidade) {
          documento.blocos.push(
            {
              titulo: 'INDICAÇÕES DE DESENVOLVIMENTO',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: ['SERVIDOR', 'RESPONSABILIDADE', 'COMPLEXIDADE', 'COMPETÊNCIAS\nTÉCNICAS'],
                  linhas: [
                    ...this.indicacoesDesempenhoSemInviabilizados.map((i) => [
                      i.nomeUsuario,
                      i.tituloResponsabilidade,
                      i.complexidadeResponsabilidade.nome,
                      i.competenciasTecnicas.length,
                    ]),
                  ],
                },
              }],
            },
            {
              titulo: 'DESEMPENHOS TÉCNICOS INVIABILIZADOS',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: ['SERVIDOR', 'MOTIVO'],
                  linhas: [
                    ...this.resultadosInviabilizadosServidor.map((r) => [
                      r.nomeUsuario,
                      r.motivoTecnicoInviabilizado,
                    ]),
                  ],
                },
              }],
            },
          );
        }

        generatePDF(documento);
      });
      this.isGetSvg = false;
    },
  },
};
</script>
